import { useMutation } from "react-query";
import api from "../../client";
import {
  CreatePlacementEnvironmentPayload,
  PlacementEnvironmentListItem,
} from "../../types/placement-environment";

const postData = async (
  payload: CreatePlacementEnvironmentPayload,
): Promise<PlacementEnvironmentListItem> => {
  const { data } = await api.post(`/placement-environments`, payload);

  return data;
};

export const useCreatePlacementEnvironment = () => {
  return useMutation((payload: CreatePlacementEnvironmentPayload) => {
    return postData(payload);
  });
};
